import { render, staticRenderFns } from "./posTerminals.vue?vue&type=template&id=65c7ec72&scoped=true&"
import script from "./posTerminals.vue?vue&type=script&lang=js&"
export * from "./posTerminals.vue?vue&type=script&lang=js&"
import style0 from "./posTerminals.vue?vue&type=style&index=0&id=65c7ec72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7ec72",
  null
  
)

export default component.exports